// src/hooks/useListings.js
// Hook pour utiliser le context des annonces - NE PAS MODIFIER

import { useContext } from 'react';
import { ListingsContext } from '../context/ListingsContext';

export const useListings = () => {
  const context = useContext(ListingsContext);

  if (!context) {
    throw new Error('useListings must be used within ListingsProvider');
  }

  return context;
};